export enum ExportBuilderColumns {
    REORDER = 'Order',
    POSITION = 'Position',
    FIELDNAME = 'Field Name',
    COLUMNHEADER = 'Column Header',
    //DATAMODEL = 'Data Model',
    ACTIONS = 'Actions',
  }
  